import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { ScheduledEmailStatus } from '../../shared/generated';
import { getLocalTranslation } from '../../utils/i18nKit';
export var getScheduledEmailStatusMap = function getScheduledEmailStatusMap() {
  var _ref;

  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return _ref = {}, _defineProperty(_ref, ScheduledEmailStatus.DONE, {
    value: ScheduledEmailStatus.DONE,
    label: $t('kit:emailStatus.done')
  }), _defineProperty(_ref, ScheduledEmailStatus.FAILED, {
    value: ScheduledEmailStatus.FAILED,
    label: $t('kit:emailStatus.failed')
  }), _defineProperty(_ref, ScheduledEmailStatus.PENDING, {
    value: ScheduledEmailStatus.PENDING,
    label: $t('kit:pending')
  }), _defineProperty(_ref, ScheduledEmailStatus.CANCELLED, {
    value: ScheduledEmailStatus.CANCELLED,
    label: $t('kit:quotes.cancelled')
  }), _defineProperty(_ref, ScheduledEmailStatus.INSTANT, {
    value: ScheduledEmailStatus.INSTANT,
    label: 'Instant'
  }), _defineProperty(_ref, ScheduledEmailStatus.IN_PROGRESS, {
    value: ScheduledEmailStatus.IN_PROGRESS,
    label: 'In Progress'
  }), _ref;
};